import { render, staticRenderFns } from "./SaveLink.vue?vue&type=template&id=73465433"
import script from "./SaveLink.vue?vue&type=script&lang=js"
export * from "./SaveLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports